import script from "./SchoolAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolAbout.vue?vue&type=script&setup=true&lang=js"

import "./SchoolAbout.vue?vue&type=style&index=0&id=507e3d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507e3d3c"]])

export default __exports__